import { useRentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { CREATE_LISTING_MUTATION_INVALIDATES } from '../../../constants/InvalidateConstants';

export const useMultiplexCreateBuildingSession = () =>
  useRentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession({
    meta: {
      invalidates: [...CREATE_LISTING_MUTATION_INVALIDATES],
      context: {
        api: 'RentalManagerUserPropertyMultiplexWebApiHandler',
        details: 'useMultiplexCreateBuildingSession',
      },
    },
  });
